import React, {useEffect} from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { useIntl } from 'react-intl';
import {buildInfo} from "./BuildInfo";
import {versionInfo} from "./VersionInfo";
import {extractBuildVersion} from "../utils/common";
import HttpClient from "../services/HttpClient";
import config from "../configs";
import {versionInfoGit} from './VersionInfoGit';
const Footer = () => {
  const intl = useIntl();

  const [version, setVersion] = React.useState(null);

  useEffect(() => {
    fetchVersion();
  }, []);
  const fetchVersion = async () => {
    const client = new HttpClient(config.API_DOMAIN_NAME);
    // client.setHeaders({ jwt: token, tenantUuid });

    // Just for testing. TODO: TO REMOVE
    console.log("versionInfoFromGit", versionInfoGit)

    try {
      const result = await client.get('/version');
      if (result?.apiVersion) {
        console.log("Version fetched from API:", result.apiVersion);
        setVersion(result.apiVersion);
      }
    } catch (err) {
      console.error("Error fetching version:", err);
    }
  };

  return( <footer className="footer">
  <Container fluid>
    <Row className="text-muted">
      <Col xs={8} className="text-left">
        <ul className="list-inline">
          <li className="list-inline-item">
            <a href="mailto:support@scanbuy.com" className="text-muted mr-1">
            {intl.formatMessage({ id: "dashboard.footer.support.defaultMessage"})}
            </a>
          </li>
          <li className="list-inline-item">
            <a href="https://scanbuy.com/site-privacy-policy" target="_blank" className="text-muted mr-1">
            {intl.formatMessage({ id: "dashboard.footer.privacy.defaultMessage"})}
            </a>
          </li>
          <li className="list-inline-item">
            <a href="https://scanbuy.com/terms-of-use"  target="_blank" className="text-muted mr-1">
            {intl.formatMessage({ id: "dashboard.footer.termsOfService.defaultMessage"})}
            </a>
          </li>
          <li className="list-inline-item">
            <a href="https://scanbuy.com/contact"  target="_blank" className="text-muted">
            {intl.formatMessage({ id: "dashboard.footer.contact.defaultMessage"})}
            </a>
          </li>
        </ul>
      </Col>
      <Col xs={4} className="text-right">

        <div>
          <p className="mb-0">
            <span className="text-muted">
             Build:{buildInfo.buildVersion}.{extractBuildVersion(version)} ({versionInfo.buildNumber})
            </span>
            &nbsp;&nbsp;
            &copy; {new Date().getFullYear()} -{" "}
            <Link to="/" className="text-muted">
              Scanbuy
            </Link>
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</footer>
);


};

export default Footer;
